export default __webpack_public_path__ + "static/media/pencil.a9008e9f.svg";